import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "googleMapsLatLng",
})
export class GoogleMapsLatLngPipe implements PipeTransform {
  transform(lat: number, lng: number): google.maps.LatLng {
    return new google.maps.LatLng({
      lat,
      lng,
    });
  }
}
